import { useContext, useEffect, useState } from 'react';

import Switch from '@mui/material/Switch';
import LaunchIcon from '@mui/icons-material/Launch';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';

import { Dialog } from '@mui/material';

import { ContextApi } from '../../context/contextApi';

import styles from './style.module.scss';
import { FormEditUser } from './formEditUser';

export function ChipUser({
    user,
    handleListUsers
}) {
    const isStatus = {
        0: false,
        1: true,
    }
    const {
        changeNewStatusUser,
        deleteUserThisId
    } = useContext(ContextApi);
    const [status, setStatus] = useState(isStatus[user.status]);
    const [showEditUser, setShowEditUser] = useState({
        show: false,
        idUser: ''
    });
    const [showExcludeUser, setShowExcludeUser] = useState({
        show: false,
        idUser: '',
        userName: ''
    })
    

    const handleShowEditUser = (id) => {
      setShowEditUser({
        show: true,
        idUser: id
      });
    };

    function handleCloseExcludeUser() {
        setShowExcludeUser({
            show: false,
            idUser: ''
        })
    }

    function handleCloseEditUser() {
        setShowEditUser({
            show: false,
            idUser: '',
            userName: ''
        });
    }

    useEffect(() => {
        setStatus(isStatus[user.status])
    }, [user])

    function handleStatusUser(e, id) {
        changeNewStatusUser(id)
        setStatus(e.target.checked)
    }

    const ShowAlertExclude = () => {
        return (
            <Dialog
            onClose={handleCloseExcludeUser} 
            open={showExcludeUser.show}
            >
                <Alert
                  variant='filled'
                  severity="error"
                  action={
                    <Button 
                    color="inherit" 
                    size="small"
                    onClick={() => {
                        deleteUserThisId(showExcludeUser.idUser);
                        handleListUsers();
                        handleCloseExcludeUser();
                    }}
                    >
                      Excluir
                    </Button>
                  }
                >
                  Excluir o usuário {showExcludeUser.userName} de forma permanente?
                </Alert>
            </Dialog>
        )
    }

    return (
        <>
            <div 
            kay={user.id} 
            className={styles.chipContainer}
            >
                <div 
                className={styles.boxClick}
                onClick={() => handleShowEditUser(user.id)}
                >
                    <LaunchIcon />
                    <span className={styles.nameUser}>{user.name}</span>
                </div>
                <div className={styles.boxSwitch}>
                    <div className={styles.boxActiveOrInactive}>
                        {status && <div className={styles.dotActive}></div>}
                        <span>{status ? 'Ativo' : 'Inativo'}</span>
                    </div>
                    <Switch 
                    defaultChecked={isStatus[user.status]}
                    value={status} 
                    onChange={(e) => handleStatusUser(e, user.id)}
                    />
                </div>
                <div 
                className={styles.excludeUserIcon}
                title='Excluír'
                onClick={() => setShowExcludeUser({
                    show: true,
                    idUser: user.id,
                    userName: user.name
                })}
                >
                    <DeleteForeverIcon />
                </div>
            </div>
            {showEditUser && 
            <FormEditUser
            showEditUser={showEditUser}
            handleCloseEditUser={handleCloseEditUser}
            />}
            <ShowAlertExclude />
        </>
    )
}